import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "consultant" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick", "onKeydown"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"])),
        class: "burger-button"
      }, "☰"),
      _createElementVNode("button", {
        type: "button",
        class: "theme-button",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.basculerTheme && _ctx.basculerTheme(...args)), ["stop"])),
        "aria-label": _ctx.themeSombre ? _ctx.$t('theme.switchToLight') : _ctx.$t('theme.switchToDark')
      }, _toDisplayString(_ctx.themeSombre ? '☀' : '☾'), 9, _hoisted_3),
      _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Thierry Martin consultant en informatique", -1))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { 'content-overlay': _ctx.store.menuVisible && _ctx.isMobile }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["menu", { 'menu-overlay': _ctx.store.menuVisible && _ctx.isMobile }]),
        ref: "menu"
      }, [
        (_ctx.store.menuVisible)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  tabindex: "0",
                  onClick: ($event: any) => (_ctx.handleMenuClick(section.value)),
                  onKeydown: ($event: any) => (_ctx.handleKeydown(section.value, $event, index)),
                  ref_for: true,
                  ref: 'menuItem'
                }, _toDisplayString(section.label), 41, _hoisted_5))
              }), 128))
            ]))
          : (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/",
                  "aria-label": "Aller à l'accueil"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.logoActif,
                      alt: "Logo de Thierry Martin consultant informatique"
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
      ], 2),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent)))
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_link, {
        class: "footer-link",
        to: "/mentions_legales",
        "aria-label": "Voir les mentions légales"
      }, {
        default: _withCtx(() => [
          _createElementVNode("small", null, "© Thierry Martin " + _toDisplayString(_ctx.copyrightYears) + " – Développé avec VueJS par mes soins", 1)
        ]),
        _: 1
      })
    ])
  ]))
}